import { format, getDate, getMonth, getYear } from 'date-fns';
import type { BirthDateType } from '../BirthDatePicker';

export const formatBirthDateToString = (birthDate: ValidDateOfBirth) => format(birthDate.date, 'yyyy-MM-dd');

export type ValidDateOfBirth = Omit<Partial<BirthDateType>, 'date'> & Pick<BirthDateType, 'date'>;

export const isDateOfBirthValid = (value?: Partial<BirthDateType>): value is ValidDateOfBirth =>
  value?.date !== undefined;

const generateBirthDateTypeValue = (birthDate: Date) => ({
  date: birthDate,
  day: getDate(birthDate),
  month: getMonth(birthDate),
  year: getYear(birthDate),
});

export const getBirthDateTypeValue = (birthdate?: Date | string) => {
  if (typeof birthdate === 'string') {
    // TODO this is hack `+ 'T00:00:00'` because Date is parsing wrong format `2023-01-01` this become different day in timezones places where going back time compared to UTC
    return generateBirthDateTypeValue(new Date(`${birthdate}T00:00:00`));
  }

  if (birthdate instanceof Date) {
    return generateBirthDateTypeValue(birthdate);
  }

  return undefined;
};
